var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{staticClass:"otium-abbreviation",attrs:{"as":"span"}},[_c('span',{staticClass:"content",attrs:{"contenteditable":"false"}},[_vm._v(_vm._s(_vm.abbreviationName))])])}
var staticRenderFns = []

export { render, staticRenderFns }